// extracted by mini-css-extract-plugin
export default {"bundleList":"FormReplacementModal_bundleList__2zE3D"};